module.exports = __webpack_public_path__ + "static/media/five-games-logo-500.ea6cb7e5.png";